module.exports = "<div class=\"text-component text-component-enabled {{extraClass}}\"> \n    {{text}}\n</div>";